
import { defineComponent } from 'vue';
import AlertMixin from '@/mixins/Alert.mixin';

export default defineComponent({
	mixins: [AlertMixin],
});
